import { TYPES } from 'action-types/booking';
import {
    IBookings,
    IBookingDetails,
} from './models';

interface IAction {
    readonly type: string;
    readonly bookings: IBookings;
    readonly bookingDetails: IBookingDetails;
    readonly errors: string[];
}
export interface IBookingState {
    readonly isFetchBookingDataLoading: boolean;
    readonly isFetchBookingDataError: boolean;
    readonly bookingDetailsPendingError: string | string[];
    readonly bookings: IBookings;
    readonly bookingDetails: IBookingDetails;
    readonly errors: string[]
}

export const defaultState: IBookingState = {
    isFetchBookingDataLoading: false,
    isFetchBookingDataError: false,
    bookingDetailsPendingError: '',
    bookings: {
        pageNumber: 1,
        page: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    errors: [],
    bookingDetails: {
        bookingId: 0,
        bookingSplitId: 0,
        documentId: 0,
        cblId: 0,
        equipmentId: 0,
        quantity: 0,
        packages: 0,
        volume: 0,
        weight: 0,
        incoTerm: '',
        booking: {
            bookingId: 0,
            bookingNumber: '',
            shipmentId: 0,
            number: '',
            incoTerm: '',
            consigneeName: '',
            consigneeFACTCode: '',
            consigneeCountryCode: '',
            consigneeBusinessEntityCode: '',
            consigneeSCVCode: '',
            originSiteCode: '',
            originSiteName: '',
            destinationSiteCode: '',
            destinationSiteName: '',
            paymentType: '',
            cargoType: '',
            bookingAgent: '',
            placeOfDeliveryCode: '',
            placeOfDeliveryName: '',
            ultimatePlaceOfDeliveryCode: '',
            ultimatePlaceOfDeliveryName: '',
            status: '',
            incoterm: '',
            officeCode: '',
            createdBy: '',
            insertDate: '',
            updatedBy: '',
            updateDate: '',
            isDeleted: false,
			specialCargoIndicator: '',
        },
        documents: [],
        cbLs: [],
        clrs: [],
        equipments: [],
        purchaseOrderNumbers: [],
        voyages: [],
        equipmentTransportShipments: [],
    }
};

export const reducer = (state: IBookingState = defaultState, action: IAction): IBookingState => {
    switch (action.type) {
        case TYPES.FETCH_BOOKING_DATA.PENDING:
            return {
                ...state,
                isFetchBookingDataLoading: true,
                isFetchBookingDataError: false,
                bookingDetailsPendingError: '',
                bookings: defaultState.bookings,
            };
        case TYPES.FETCH_BOOKING_DATA.FULFILLED:
            return {
                ...state,
                bookings: action.bookings,
                isFetchBookingDataLoading: false,
                isFetchBookingDataError: false,
                bookingDetailsPendingError: ''
            };
        case TYPES.FETCH_BOOKING_DATA.REJECTED:
            return {
                ...state,
                isFetchBookingDataLoading: false,
                isFetchBookingDataError: true,
                bookingDetailsPendingError: action.errors
            };
        case TYPES.FETCH_BOOKING_DETAILS.PENDING:
            return {
                ...state,
                isFetchBookingDataLoading: true,
                bookingDetailsPendingError: ''
            };
        case TYPES.FETCH_BOOKING_DETAILS.FULFILLED:
            return {
                ...state,
                isFetchBookingDataLoading: false,
                bookingDetails: action.bookingDetails || defaultState.bookingDetails
            };
        case TYPES.FETCH_BOOKING_DETAILS.REJECTED:
            return {
                ...state,
                isFetchBookingDataError: true,
                isFetchBookingDataLoading: false,
                bookingDetailsPendingError: action.errors
            };
        case TYPES.FETCH_BOOKING_DETAILS.RESET_ERROR:
            return {
                ...state,
                isFetchBookingDataError: true,
                bookings: action.bookings,
            };
        case TYPES.FETCH_RESET_DATA.PENDING:
            return {
                ...state,
                bookingDetailsPendingError: ''
            };
        case TYPES.FETCH_RESET_DATA.FULFILLED:
            return {
                ...state,
                bookings: action.bookings,
            };
        case TYPES.FETCH_RESET_DATA.REJECTED:
            return {
                ...state,
                isFetchBookingDataError: true,
                bookingDetailsPendingError: action.errors
            };
        default:
            return state;
    }
};
